import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { CommonBindingDataService } from './../../services/common-binding-data.service';

@Component({
  selector: 'app-notification-mg1',
  templateUrl: './notification-mg1.component.html'
})

export class NotificationMG1Component implements OnInit {
  @Input() notifications;
  @Input() notificationCount;
  @Output() loadMoreNotification: EventEmitter<any> = new EventEmitter();
  @Output() notificationClicked: EventEmitter<any> = new EventEmitter();
  @Input() showMoreOff = false;
  message: Message[] = [];
  labelLoadMore = '';

  constructor(private commonBindingDataService: CommonBindingDataService,
    private router: Router,
    ) { }

  ngOnInit() {
    this.labelLoadMore = this.commonBindingDataService.getLabel('label_load_more_notifications');
  }

  onLoadMore() {
    this.loadMoreNotification.emit();
  }


  notificationRout(event) {
    const extaraParams = event['extraParams'].split('~');
    if (extaraParams[0] === 'TEAM_DISPATCH_STATUS_UPDATED_WEB' || extaraParams[0] === 'ADMIN_NEW_DISPATCH_CREATED_WEB'
    || extaraParams[0] === 'ADMIN_TEAM_DISPATCH_ASSIGNED_WEB' || extaraParams[0] === 'DISPATCH_ASSIGN_REMAINDER_WEB'
    || extaraParams[0] === 'ADMIN_CANCELLED_DISPATCH_WEB_ONSCENE' || extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_DELAY_WEB'
    || extaraParams[0] === 'ADMIN_CANCELLED_DISPATCH_WEB_ENROUTE' || extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_NOTES_WEB'
    || extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_SAFE_WEB' || extaraParams[0] === 'DISPATCH_ASSIGN_REMAINDER_MOBILE'
    || extaraParams[0] === 'PROVIDER_DISPATCH_ASSIGNED_WEB') {
      this.router.navigate(['/dispatch-request/edit-dispatch-request'], { queryParams: { id: extaraParams[1]}})
      .then(() => {
        // window.location.reload();
      });
    }
    // tslint:disable-next-line:max-line-length
    // else if (extaraParams[0] === 'CONTACT_FORM_CREATED_WEB' || extaraParams[0] === 'CONTACT_FORM_UPDATED_WEB' || extaraParams[0] === 'FOLLOW_UP_CREATED_WEB') {
    //   this.router.navigate(['/contact-form/edit-contact-form'], { queryParams: { id: extaraParams[1]}})
    //   .then(() => {
    //     window.location.reload();
    //   })
    // }
    this.notificationClicked.emit();
  }

  notificationStatus(notificationObj) {
    const extaraParams = notificationObj['extraParams'].split('~');
    if (extaraParams[0] === 'TEAM_DISPATCH_STATUS_UPDATED_WEB' || extaraParams[0] === 'CONTACT_FORM_CREATED_WEB'
    || extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_DELAY_WEB' || extaraParams[0] === 'ADMIN_CANCELLED_DISPATCH_WEB_ENROUTE'
     || extaraParams[0] === 'CONTACT_FORM_UPDATED_WEB' || extaraParams[0] === 'ADMIN_NEW_DISPATCH_CREATED_WEB'
     || extaraParams[0] === 'ADMIN_TEAM_DISPATCH_ASSIGNED_WEB' || extaraParams[0] === 'DISPATCH_ASSIGN_REMAINDER_WEB'
     || extaraParams[0] === 'ADMIN_CANCELLED_DISPATCH_WEB_ONSCENE' || extaraParams[0] === 'FOLLOW_UP_CREATED_WEB'
     || extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_NOTES_WEB' || extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_SAFE_WEB'
     || extaraParams[0] === 'DISPATCH_ASSIGN_REMAINDER_MOBILE' || extaraParams[0] === 'PROVIDER_DISPATCH_ASSIGNED_WEB') {
      return true;
    } else {
    return false;
    }
  }

  notificationStatusColor(notificationObj) {
    const extaraParams = notificationObj['extraParams'].split('~');
    if (extaraParams[0] === 'DISPATCH_ASSIGN_REMAINDER_WEB' || extaraParams[0] === 'DISPATCH_ASSIGN_REMAINDER_MOBILE') {
    return 'rgba(247, 176, 176, 0.99)';
    } else if (extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_DELAY_WEB') {
      return 'rgb(249, 187, 74)';
    } else if (extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_NOTES_WEB') {
      return 'rgb(132, 242, 247)';
    } else if (extaraParams[0] === 'ADMIN_PROVIDER_DISPATCH_SAFE_WEB') {
      return 'rgb(174, 254, 174)';
    }

  }


}
